import { BaseBus } from './BaseBus';
import { DateFunctions } from '../static/date-functions';
import { v_LocationDetailBus } from './v_LocationDetailBus';
import { EquipFieldData } from './EquipFieldData';
import { CommonFunctions } from '../static/common-functions';
/*
 * hidden - dispatchEquipmentXrefId
 * hidden - dispatchId
 * (checkbox)
 *Equipment Id: systemId
 * Manufacturer: manufacturerName manufacturerId
 * Model : model
 * (Additional Details - button)
 * Serial #: serialNumber
 * Type: manufacturerTypeName manufacturerTypeId
 * Barcode: barcode
 * Notes: notes
 * Created By: createdBy
 * Date Created: creationDate;
 * (View Inventory Items Used - button)
 */
export class ExpenseDetailViewBus extends BaseBus
{
    constructor(data: ExpenseDetailViewBus) {
        super(data);
    }

    setId(id: any) {
        this.miscExpenseId = id;
    }
    initialize(data: ExpenseDetailViewBus) {
        super.initialize(data);
        this.expenseDate = CommonFunctions.getDate(data.expenseDate);
        this.updateDt = CommonFunctions.getDate(data.updateDt);
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
    }
    setFromForm(data: ExpenseDetailViewBus) {
        super.setFromForm(data);
        let dateNow = CommonFunctions.getDateNow();
        //this.updateDt = dateNow;
        //if (this.hasId) {
        //    //this.updateDt = dateNow;
        //    this.insertDt = data.insertDt;
        //    this.insertUserId = data.insertUserId;
        //}
        //else {
        //    this.insertDt = dateNow;
        //    this.insertUserId = data.insertUserId;
        //}

    }
    setBeforeSave() {
        //this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        // this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);
    }
    setCommon(userId: any, date: Date, companyId: any = null) {
        if (this.hasId) {
          //  this.updateUserId = userId;
        }
        else {
            //this.insertDt = date;
            //this.insertUserId = userId;
            //this.updateUserId = userId;
        }
    }

    cos: string;
    creditCard: string;
    empNo: string;
    incomeStatementCat: string;
    lineOfBusiness: string;
    managerName: string;
    costCenterName: string;
    brnch: string;
    costCtr: string;
    resourceName: string;
    note: string;
    approved: boolean;
    sentToPayroll: boolean;
    toBeDeleted: boolean;
    isNew: boolean;
    needsReimbursement: boolean;
    photoCount: Number;
    totalPhotos: Number;
    amount: Number;
    materialType: string;
    vendorName: string;
    expenseDateFmt: string;
    ovh: string;
    branchCode: string;
    updateDt: Date;
    expenseDate: Date;
   // UpdateDt: Date;

    miscExpensePhotoId: string;

    personId: string;

    miscExpenseId: string;

}
